<template>
  <div class="LED_management">
    <div style="padding: 0px 20px;height: 100%">
      <div class="search">
        <div class="search_box">
          <div v-for="item in search" :class='["search_options_box"]'>
            <span style="width: 100px;">{{item.title}}</span>
            <el-select class="select" v-model="selectValue" placeholder="请选择项目" @change="getSelectProject(selectValue )">
              <el-option v-for="item2 in item.options" :label="item2.label" :value="item2.value" :key="item2.value"></el-option>
            </el-select>
          </div>
          <div class="search_btn_box">
            <button :class='["search_btn","green","icon_btn","clearborder"]'><span class="el-icon-search"></span>搜索</button>
          </div>
          <div class="table_btn_box">
            <button :class='["search_btn","add","icon_btn","clearborder"]' @click="UpData = !UpData"><span class="el-icon-circle-plus-outline"></span>添加
            </button>
            <button :class='["search_btn","warning","icon_btn","clearborder"]' @click="BatchDelete()"><span
              class="el-icon-delete"></span>批量删除
            </button>
          </div>
        </div>
      </div>


      <div :class='["information_box","light_border"]'
           :style="[{width:'100%'},{height:'calc(100% - 244px)'},{'margin':'20px 0'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <ul class="led_content">
            <li v-for="(item,index) in table_data">
              <div v-if="item.type==='IMG'">
                <div>
                  <img style="width: 208px;height:468px;" :src="'http://27.128.181.220:9998' + item.file_url"
                       :alt="item.name">
                </div>
                <input type="checkbox" :value="item.id" v-model="CheckedData">
                <p>资源名称:{{item.name}}</p>
                <p>资源大小:{{item.file_size}}</p>
              </div>
              <div v-else>
                <div>
                  <video width="208px" height="468px" controls>
                    <source :src="'http://27.128.181.220:9998' + item.file_url" type="video/mp4">
                    <source :src="'http://27.128.181.220:9998' + item.file_url" type="video/ogg">
                  </video>
                </div>
                <input type="checkbox" :value="item.id" v-model="CheckedData">
                <p>资源名称:{{item.name}}</p>
                <p>资源大小:{{item.file_size}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="table_paging">
        <p>当前记录<span>{{(this.currentPage-1)*9+1}}</span>到<span>{{(this.currentPage-1)*9+this.historyData.length}}</span>条，共<span>{{this.totalPage}}</span>条记录
          <button @click="FirstPage()"
                  v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
          <button
            @click="prevPage()" v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
          第<span>{{currentPage}}</span>/<span>{{Math.ceil(totalPage/pageSize)}}</span>页
          <button
            @click="nextPage()" v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
          <button @click="LastPage()"
                  v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
        </p>
      </div>
    </div>


    <transition name="fade">
      <div class="mark" v-if="Delete">
        <div class="mark_close" @click="Delete=!Delete"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'500px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              批量删除
            </h1>
            <div style="padding: 0 60px;box-sizing: border-box">
              <h1>是否要删除已选择的资源</h1>
            </div>
            <div class="sbt_box">
              <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="Delete=!Delete">取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="Delete_sbt()">确定</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="mark" v-if="UpData">
        <div class="mark_close" @click="UpData=!UpData"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'500px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              上传素材
            </h1>
            <div style="padding: 0 60px;box-sizing: border-box">
              <el-upload
                class="upload-demo"
                ref="upload"
                :action="params.action"
                :data="params.data"
                accept=".jpg,.JPG,.JPEG,.png,.PNG,.MP4,"
                :on-change="uploadOnChange"
                :file-list="fileList"
                :auto-upload="false">
                <button name="" slot="trigger" type="primary" :class='["add_btn","add","icon_btn","clearborder"]'>选择文件</button>
                <div slot="tip" class="el-upload__tip" style="color: #FFFFFF;font-size: 14px">只能上传jpg/png/mp4文件，且不超过2MB</div>
              </el-upload>


            </div>
            <div class="sbt_box">
              <button :class='["add_btn","publish","icon_btn","clearborder"]' @click="success()">完成</button>
              <button :class='["add_btn","publish","icon_btn","clearborder"]' @click="submitUpload">上传服务器</button>
            </div>
          </div>
        </div>
      </div>
    </transition>


    <transition name="fade" v-on:leave="leave">
      <div class="mark" v-if="msg_show">
        <div class="mark_close" @click="msg_show=!msg_show"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'500px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="information_content issue_search_box model">
            <div id="msg">{{message}}</div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  //引入echarts
  export default {
    name: "LED_management",
    data() {
      return {
        search: [
          {
            title: '选择项目',
            options: [],
          },
        ],
        selectValue:'',
        projectList:[],
        table_data: [],
        data: [
          {
            porject: "项目1", children: [{}]
          }
        ],
        CheckedData: [],
        //弹窗
        refresh: false,
        fix_show: false,
        Delete: false,//删除
        UpData: false,//上传
        fileList: [],
        msg_show: false,//消息弹窗
        message: "",//消息内容
        project_id:"1",

        params:{
          action:"/api/v1/led/resource/add",
          data: {"project_id":"1"}
        },
        //分页
        totalPage:'', // 统共页数，默认为1
        currentPage: 1, //当前页数 ，默认为1
        pageSize: 6, // 每页显示数量
        historyData: [],
      }
    },
    methods: {
      InitLeftMenu: function () {
        this.$emit('getMessage', '4', '1');
      },

      //获取项目列表
      getProjectList:function(){
        fetch("/api/v1/project/list", {
          method: 'post',
          body: JSON.stringify({

          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "项目数据获取成功";
              this.projectList = data.data;
              let options = this.search[0].options;
              for (let i=0;i<this.projectList.length;i++){
                let projectObj = {};
                projectObj.label = this.projectList[i].name;
                projectObj.value = this.projectList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },

      Getlist: function () {
        //获取媒体资源列表
        fetch("/api/v1/led/resource/list", {
          method: 'post',
          body: JSON.stringify({
            // "project_id": "f899dfb4a9094ac48fbb27b64021d5e1",
            "page_start": 0,
            "page_size": 6,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            console.log(data.data)
            this.table_data = data.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      //上传

      myData:function(){
        return {
          "project_id":this.project_id,
        }
      },
      submitUpload() {
        // console.log(this.fileList)
        this.$refs.upload.submit();
      },
      uploadOnChange(file, fileList){
        console.log(fileList)
      },
      //批量删除
      BatchDelete: function () {
        if (this.CheckedData.length > 0) {
          this.Delete = !this.Delete
        } else {
          this.msg_show = !this.msg_show;
          this.message = "请选择媒体资源"
        }
      },
      Delete_sbt: function () {
        fetch("/api/v1/led/resource/delete", {
          method: 'post',
          body: JSON.stringify({
            "resource_id": this.CheckedData,
          })
        }).then(res => {
          return res.json();//解析流
        }).then(data => {
          if (data.code == "2000") {
            this.Delete = !this.Delete;
            this.msg_show = !this.msg_show;
            this.message = data.msg
          } else {
            this.message = "删除成功";
            this.Delete = !this.Delete;
            this.refresh = true;
            this.msg_show = !this.msg_show;
          }

        })
      },
      success:function(){
        this.UpData = !this.UpData;
        this.refresh = true;
        this.msg_show = !this.msg_show;
        this.message = "添加完成";
      },

      //刷新页面
      leave: function () {
        if (this.refresh) {
          this.$router.push({path: '/monitoring/null'})
        }
      },
     
    },
    mounted() {

    },
    created() {
      this.InitLeftMenu();
      this.getProjectList();
      this.Getlist();
      //页面刚进入时开启长连接
      // this.initWebSocket();
    },
    destroyed: function() {
      //页面销毁时关闭长连接
      this.webSocketClose();
    },
  }
</script>

<style scoped>
  .LED_resource {
    width: 100%;
    height: 100%;
  }

  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0 0;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .search_options_box {
    width: 16%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .table_btn_box {
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 63%;
  }

  .table_btn_box > button {
    margin-left: 10px;
    width: 100px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .add {
    background: #7aafeb;
    color: #FFFFFF;
    box-shadow: 0 3px 0 #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }

  .download {
    background: #21b868;
    color: #FFFFFF;
    box-shadow: 0 3px 0 #18884d;
  }

  .download:active {
    background: #19ad5f;
  }


  .nva_btn {
    padding: 20px;
  }

  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .led_content {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 15px 30px;
    box-sizing: border-box;
  }

  .led_content > li {
    padding: 5px 24px;
    height: auto;
    float: left;
  }

  .led_content > li > div {
    position: relative;
  }

  .led_content > li > div > div {
    width: 208px;
    height: 468px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .led_content > li > div > div > img ，.led_content > li > div > div > video {

    max-width: 100%;
    max-height: 100%;
  }

  .led_content > li > div > input {
    position: absolute;
    left: 0;
    bottom: 10px;
  }

  .led_content > li > div > p {
    padding-left: 30px;
    box-sizing: border-box;
    margin-bottom: 5px;
    color: #FFFFFF;
    text-align: left;
    font-size: 14px;
  }
</style>




// WEBPACK FOOTER //
// src/components/03Monitoring/5_msg/LED_resource.vue